<app-modal-header
  [highlighted]="false"
  (close)="close()">

  <ng-container slot="breadcrumb">
    <span>
      {{ 'admin.session-detail-card-modal.breadcrumb' | translate }}
      @if (sessionData) {
        • <span class="font-normal">{{ 'admin.session-detail-card-modal.nth-session-label' | translate:{ nth: sessionData.index + 1 } }}</span>
      }
    </span>
  </ng-container>

  <ng-container slot="title">
    @if (sessionData) {
      {{ sessionData.shopItem.title}}
    }
  </ng-container>

  @if (sessionData && sessionData.title) {
    <ng-container slot="undercontent">
      <span class="text-bluegray-400">
        {{ sessionData.title }}
      </span>
    </ng-container>
  }

</app-modal-header>

<div class="modal-body pt-3">
  
  @if (sessionData) {

    @if (infoCardBlock1.length) {
      <div class="info-card-grid">
        @for (cardType of infoCardBlock1; track cardType) {
          <ng-container *ngTemplateOutlet="infoCardTemplate; context: { cardType: cardType }"></ng-container>
        }
      </div>
    }

    @if (infoCardBlock2.length && infoCardBlock1.length) {
      <div class="mt-3"></div>
    }

    @if (infoCardBlock2.length) {
      <div class="info-card-grid">
        @for (cardType of infoCardBlock2; track cardType) {
          <ng-container *ngTemplateOutlet="infoCardTemplate; context: { cardType: cardType }"></ng-container>
        }
      </div>
    }


    @if (type === SessionDetailCardModalType.LECTURER) {
      <p-divider class="compensate-modal-body-x-padding block"></p-divider>

      <h5 class="text-bluegray-400 mt-3 mb-4 text-sm uppercase">
        {{ 'admin.session-detail-card-modal.my-work-statement-label' | translate }}
      </h5>
      <app-session-lecturer-attendance-input-group #sessionLecturerAttendanceInputGroup [sessionId]="sessionData.id" [type]="SessionLecturerType.REGULAR"></app-session-lecturer-attendance-input-group>
  
    }

  }
</div>


<div class="modal-footer">
  <app-modal-footer-menu
    [items]="footerMenuItems">
  </app-modal-footer-menu>
</div>




<ng-template #infoCardTemplate let-cardType="cardType">

  @if (sessionData) {
    @switch (cardType) {
      @case (SessionDetailCardInfoCardType.DATETIME) {
        <div class="info-card">
          <i class="pi pi-calendar info-card__icon"></i>
          <div class="info-card__text">
            {{ siHelper.getSessionDate(sessionData.startAt) }}
            {{ siHelper.getSessionYear(sessionData.startAt) }}
            <span class="lowercase">
              {{ siHelper.getSessionDay(sessionData.startAt, 'EEEE') }}
            </span>
          </div>
        </div>
      }
      @case (SessionDetailCardInfoCardType.TIME) {
        <div class="info-card">
          <i class="pi pi-clock info-card__icon"></i>
          <div class="info-card__text">
            {{ siHelper.getSessionTimeRange(sessionData.startAt, sessionData.endAt) }}
          </div>
        </div>
      }
      @case (SessionDetailCardInfoCardType.LOCATION) {
        @if (sessionData.meetingUrl) {
          <div (click)="onMeetingUrl(sessionData.meetingUrl)" class="info-card cursor-pointer">
            <i class="pi pi-link info-card__icon"></i>
            <div class="info-card__text">
              {{ 'admin.session-detail-card-modal.meeting-url-label' | translate }}
            </div>
          </div>
        } @else if (sessionData.format === SessionFormat.ONLINE) {
          <div class="info-card">
            <i class="pi pi-wifi info-card__icon"></i>
            <div class="info-card__text">
              {{ 'SessionFormat.ONLINE' | translate }}
            </div>
          </div>
        }
        @if (sessionData.location) {
          <div (click)="onLocationMapUrl(sessionData.location.mapUrl)" [ngbTooltip]="sessionData.location.mapUrl ? sessionData.location.internalTitle || sessionData.location.title : null" class="info-card" [class.cursor-pointer]="sessionData.location.mapUrl">
            <i class="pi pi-map info-card__icon"></i>
            <div class="info-card__text">
              @if (sessionData.location.mapUrl) {
                {{ 'admin.session-detail-card-modal.show-map-label' | translate }}
              } @else {
                {{ sessionData.location.internalTitle || sessionData.location.title }}
              }
            </div>
          </div>
        }
      }
      @case (SessionDetailCardInfoCardType.CHECKIN) {
        <div class="info-card cursor-pointer" (click)="onCheckin()">
          <i class="pi pi-qrcode info-card__icon"></i>
          <div class="info-card__text">
            {{ 'admin.session-detail-card-modal.checkin-label' | translate }}
          </div>
        </div>
      }
      @case (SessionDetailCardInfoCardType.SEND_MESSAGE) {
        <div class="info-card cursor-pointer" (click)="onSendMessage()">
          <i class="pi pi-envelope info-card__icon"></i>
          <div class="info-card__text">
            {{ 'admin.session-detail-card-modal.send-message-label' | translate }}
          </div>
        </div>
      }
      @case (SessionDetailCardInfoCardType.PARTICIPANTS) {
        <div class="info-card cursor-pointer" (click)="onParticipants()">
          <div class="info-card__title">
            {{ participantCountValue }}
          </div>
          <div class="info-card__text">
            {{ 'admin.session-detail-card-modal.participants-count-label' | translate }}
          </div>
        </div>
      }
      @case (SessionDetailCardInfoCardType.MATERIALS) {
        <div class="info-card cursor-pointer" (click)="onMaterials()">
          <i class="pi pi-copy info-card__icon"></i>
          <div class="info-card__text">
            {{ 'admin.session-detail-card-modal.transcript-materials-label' | translate }}
          </div>
        </div>
      }
      @case (SessionDetailCardInfoCardType.PARTICIPANT_ATTENDANCE) {
        <div class="info-card cursor-pointer" (click)="onParticipantAttendance()">
          @if (participantAttendanceStatus === 'some-unfilled') {
            <i class="pi pi-question info-card__status-icon"></i>
          } @else if (participantAttendanceStatus === 'all-filled') {
            <i class="pi pi-check info-card__status-icon"></i>
          }
          <i class="pi pi-users info-card__icon"></i>
          <div class="info-card__text">
            {{ 'admin.session-detail-card-modal.attendance-label' | translate }}
          </div>
        </div>
      }
        
    }
  }

</ng-template>